import { IDetailCruise, IDetailRoute, IDetailShip } from './interfaces'

export const useState = (): CruiseState => {
  return {
    cruise: null,
    ship: null,
    route: null,
    isCruiseLoading: false,
    requestId: ''
  }
}

export interface CruiseState {
  cruise: IDetailCruise | null
  ship: IDetailShip | null
  route: IDetailRoute | null
  isCruiseLoading: boolean
  requestId: string
}
